export default __webpack_public_path__ + "22.c450e1.svg";